'use es6';

import LayoutSectionEmptyPlaceholderContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionEmptyPlaceholderContainer';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAllLayoutSectionIds, getAllGridLayoutIds } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import GridLayoutEmptyPlaceholderContainer from './GridLayoutEmptyPlaceholderContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class LayoutSectionEmptyPlaceholdersContainer extends Component {
  render() {
    const {
      allLayoutSectionIds,
      allGridLayoutIds,
      dispatchActionToEventBus
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [allLayoutSectionIds.map(layoutSectionId => {
        return /*#__PURE__*/_jsx(LayoutSectionEmptyPlaceholderContainer, {
          dispatchActionToEventBus: dispatchActionToEventBus,
          layoutSectionId: layoutSectionId
        }, `__hs-ls-empty-placeholder-${layoutSectionId}`);
      }), allGridLayoutIds.map(gridLayoutId => {
        return /*#__PURE__*/_jsx(GridLayoutEmptyPlaceholderContainer, {
          gridLayoutId: gridLayoutId
        }, `__hs-grid-empty-placeholder-${gridLayoutId}`);
      })]
    });
  }
}
LayoutSectionEmptyPlaceholdersContainer.propTypes = {
  allLayoutSectionIds: PropTypes.array.isRequired,
  dispatchActionToEventBus: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    allLayoutSectionIds: getAllLayoutSectionIds(state),
    allGridLayoutIds: getAllGridLayoutIds(state)
  };
};
export default connect(mapStateToProps)(LayoutSectionEmptyPlaceholdersContainer);